/* ============
 * Mutations for the user module
 * ============
 *
 * The mutations that are available on the
 * user module.
 */

export default {
  setPopupNpsFinal (state, payload) {
    state.popupNpsFinal = payload
  },
  setTaggeoNps (state, payload) {
    state.taggeoNps = {...state.taggeoNps, ...payload}
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/nps/mutations.js